
export const SOLACE_PRICEING_DATA = `SOLACE_PRICEING_DATA`

export const getSolacePricingData = (payload:any): any => {
	return {
		type: SOLACE_PRICEING_DATA,
		payload
	}
}